import React from "react";
import { api, googleEvent } from "../../api";
import "./resumebooking.css";
import * as Images from "../../themes/images";
import { instanceOf } from "prop-types";
import HeaderMobile from "../../components/headerMobile";
import { withCookies, Cookies } from "react-cookie";
import Loading from "../../components/Loading";
import ReactPixel from "react-facebook-pixel";

class ResumeBookingSuccess extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      bookingNumber: false,
      error: false,
      errorMessage: "",
      loading: true,
    };
    this.getResumeBooking = this.getResumeBooking.bind(this);
  }

  async getResumeBooking() {
    const { cookies } = this.props;
    const queryParams = new URLSearchParams(window.location.search);
    const bookingKey = queryParams.get("bookingKey");
    const sessionId = queryParams.get("session_id");

    console.log("bookingKey: ", bookingKey);
    console.log("sessionId: ", sessionId);

    if (!bookingKey) {
      console.error("No bookingKey found in URL parameters");
    }
    if (!sessionId) {
      console.error("No sessionId found in URL parameters");
    }

    if (!bookingKey || !sessionId) {
      this.setState({
        error: true,
        errorMessage: "Invalid booking session. Please try again.",
        loading: false,
      });
      return;
    }

    // First, verify payment and complete the booking
    let confirmData = {
      bookingKey: bookingKey,
      sessionId: sessionId,
    };

    console.log("Sending confirmation data to backend:", confirmData);

    try {
      let confirmRes = await api(
        "booking/resume/confirmed",
        "POST",
        confirmData
      );
      if (confirmRes.status === 200 && confirmRes.data.success) {
        // Booking was successfully completed
        this.setState({
          bookingNumber: confirmRes.data.bookingNumber,
          loading: false,
        });

        cookies.set("bookingNumber", confirmRes.data.bookingNumber, {
          path: "/",
          maxAge: 86400,
        });

        cookies.remove("cartId", { path: "/", maxAge: 86400 });
        cookies.remove("confirmStep", { path: "/", maxAge: 86400 });
        cookies.remove("extrasStep", { path: "/", maxAge: 86400 });
        cookies.remove("detailsStep", { path: "/", maxAge: 86400 });
        cookies.remove("serviceStep", { path: "/", maxAge: 86400 });

        // Fire Google Event on booking confirmed
        // googleEvent("booking_confirmed", { bookingNumber: confirmRes.data.bookingNumber });
      } else {
        this.setState({
          error: true,
          errorMessage:
            confirmRes.data.message ||
            "Failed to complete booking. Please contact support.",
          loading: false,
        });
      }
    } catch (error) {
      console.error("Error completing booking:", error);
      this.setState({
        error: true,
        errorMessage:
          "An error occurred while completing your booking. Please contact support.",
        loading: false,
      });
    }
  }

  setupBeforeUnloadListener = () => {
    const parentState = this;
    window.addEventListener("beforeunload", (ev) => {
      if (parentState.state.loading) {
        ev.preventDefault();
        return (ev.returnValue =
          "Are you sure you want to close? Your booking has not been processed yet and you may forfeit your $2 booking fee.");
      } else {
        return;
      }
    });
  };

  componentDidMount() {
    document.title = "Booking Success - Concierge Car Wash";
    const { cookies } = this.props;
    const queryParams = new URLSearchParams(window.location.search);
    ReactPixel.pageView();

    this.getResumeBooking();

    this.setState({
      bookingNumber: cookies.get("bookingNumber")
        ? cookies.get("bookingNumber")
        : false,
    });

    this.setupBeforeUnloadListener();
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="bookingSuccessPage">
          {window.innerWidth < 767 && <HeaderMobile />}
          <div className="bookingBanner">
            <img src={Images.ccwWhiteLogo} className="bannerLogo" alt="logo" />
          </div>
          <div className="watingMessage">
            <h1>
              We are processing your booking, please do not leave this page
              until you recieve your booking reference number.
            </h1>
          </div>
          <Loading />
        </div>
      );
    }

    return (
      <div className="bookingSuccessPage">
        {window.innerWidth < 767 && <HeaderMobile />}
        <div className="bookingBanner">
          <img src={Images.ccwWhiteLogo} className="bannerLogo" alt="logo" />
        </div>
        {this.state.error ? (
          <div className="failContent">
            <h1>{this.state.errorMessage}</h1>
            <div className="backToWebsite">
              <a
                className="lightBlueButton"
                href={"https://conciergecarwash.com.au"}
              >
                {" "}
                Continue{" "}
              </a>
            </div>
          </div>
        ) : (
          <div className="successContent">
            <img
              src={Images.blueTick}
              className="successTick"
              alt="success tick"
            />
            <h1>You successfully confirmed your booking.</h1>
            {this.state.bookingNumber !== false && (
              <>
                <h3 className="bookingNumber">
                  Booking # {this.state.bookingNumber}
                </h3>
                <p className="note">
                  <b>Please Note</b>
                </p>
                <p className="note">
                  <b>Pricing:</b> The total price is an estimate, and an exact
                  quote will be given on the day. Prices vary depending on the
                  state, size and condition of your vehicle.
                </p>
                <p className="note">
                  <b>Time:</b> We will do our best to facilitate your
                  reservation time; however, at times, delays can occur. The
                  team will inform you of the estimated completion time.
                </p>
              </>
            )}
            <div className="backToWebsite">
              <a
                className="lightBlueButton"
                href={"https://conciergecarwash.com.au"}
              >
                {" "}
                Continue{" "}
              </a>
            </div>
          </div>
        )}
        <footer class="successFoooter">
          <img src="https://hustleoutbound.s3.ap-southeast-2.amazonaws.com/637b47ec89db6c2ec519888a_ccwCleanCar.jpeg " />
        </footer>
      </div>
    );
  }
}

export default withCookies(ResumeBookingSuccess);
